module.exports = __webpack_public_path__ + "images/liinilaevad/routes/pointers/KEL-LEP-KEL.png";